<template>
  <button
    class="flex w-full items-stretch rounded-lg text-left"
    :class="{
      [backgroundColorToTailwindMap[backgroundColor!]]: !!backgroundColor && !selected,
      'bg-grey-25': !backgroundColor && !selected,
      'bg-emo-deep-blue': selected,
    }"
    @click="$emit('icon:clicked')"
  >
    <div
      class="min-w-2 rounded-l-lg"
      :class="{
        [leadingColorToTailwindMap[leadingColor!]]: leadingColor !== undefined,
      }"
    ></div>

    <div class="flex w-full flex-1 items-center text-clip py-[10px] pl-4 pr-2">
      <div class="flex items-center gap-4">
        <gv-image class="size-10" :src="props.icon" :alt="title + ' icon'" />
        <div class="flex w-[175px] flex-1 flex-col 3xs:w-[214px] 2xs:w-[248px] xs:w-[344px]">
          <gv-type uplifted-variant="subtitle-sm" :text="title" breakpoint="none" :class="{ 'text-white': selected }" />
          <div
            class="overflow-hidden font-proxima-nova text-[1rem] font-normal leading-[1.4]"
            :class="{ 'text-white': selected }"
            v-html="useSanitiseHtml(description)"
          ></div>
          <gv-type
            uplifted-variant="caption"
            :text="relativePublishedAgo ?? undefined"
            breakpoint="none"
            :class="{ 'text-white': selected }"
          />
        </div>
      </div>

      <div class="ml-auto flex h-full flex-col justify-center">
        <gv-icon name="add_box" size="md" class="cursor-pointer" :class="{ 'fill-white': selected }" />
      </div>
    </div>
  </button>
</template>

<script setup lang="ts">
import { useSanitiseHtml } from '@/common';
import { UiListTileBackgroundColor, UiListTileLeadingColor } from '@/features/hazards';
import { i18n } from '@/locales';
import { DateTime } from 'luxon';
import { computed } from 'vue';

const props = defineProps<{
  leadingColor?: UiListTileLeadingColor;
  backgroundColor?: UiListTileBackgroundColor;
  title?: string;
  description?: string;
  publishedAt?: string;
  icon?: string;
  selected?: boolean;
}>();

defineEmits<{
  (event: 'icon:clicked'): void;
}>();

const { locale } = i18n.global;

const relativePublishedAgo = computed(() => {
  // Track locale changes
  void locale.value;

  if (!props.publishedAt) {
    return '';
  }

  const parsedDate = DateTime.fromISO(props.publishedAt);

  return parsedDate.toRelative();
});

const leadingColorToTailwindMap = {
  [UiListTileLeadingColor.Black]: 'bg-ribbon-black',
  [UiListTileLeadingColor.Gray]: 'bg-ribbon-green',
  [UiListTileLeadingColor.Blue]: 'bg-ribbon-blue',
  [UiListTileLeadingColor.Yellow]: 'bg-ribbon-yellow',
  [UiListTileLeadingColor.Orange]: 'bg-ribbon-orange',
  [UiListTileLeadingColor.Red]: 'bg-ribbon-red',
};

const backgroundColorToTailwindMap = {
  [UiListTileBackgroundColor.Pink]: 'bg-pink-50',
  [UiListTileBackgroundColor.Orange]: 'bg-orange-50',
};
</script>
